// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-grey[data-v-77155c5d] {\n  background-color: #8799a3;\n  color: #fff;\n}\n.text-black[data-v-77155c5d] {\n  color: #333;\n}\n.ov-h[data-v-77155c5d] {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
